import type { Locale } from './types';
import { DEFAULT_LOCALE, translations } from './translations';

export function getBrandName(locale: Locale = DEFAULT_LOCALE): string {
  const dict = translations[locale] ?? translations[DEFAULT_LOCALE];

  return locale === 'en' ? dict['nav.brand_name_en'] : dict['nav.brand_name_zh'];
}
